import { colors } from "@material-ui/core";
import React from "react";
import * as Sentry from "@sentry/browser";
import { useAlert } from "react-alert";

import { makeRequest } from "../../../util";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { FacebookIcon } from "../../../components/icons/themes/color";

const AdAccountIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["adAccountId"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const AdAccountIDRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "adAccountId" in settings;

  return (
    <DestinationConfigRow
      name="Ad Account ID"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthModal = () => {
  return null;
};

const OAuthRow = ({ existingConfig }) => {
  const alert = useAlert();
  const config = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in config;

  const onOpenConfigModal = () => {
    makeRequest("get_oauth_url", {
      integration_name: "facebook-custom-audiences",
      destination_id: config?.id,
    })
      .then((response) => {
        window.location = response.data;
      })
      .catch((error) => {
        console.log(error);
        Sentry.captureException(error);
        alert.error("Something went wrong. Unable to setup Facebook.");
      });
  };

  const loginButton = (
    <div
      className="rounded bg-thirdParty-facebookBlue text-white px-2 py-1 w-auto inline-block cursor-pointer font-semi-bold"
      onClick={onOpenConfigModal}
    >
      <FacebookIcon
        className="mr-2 fill-white position"
        height="2em"
        style={{ top: -2 }}
      />
      {oauthConfigured ? "Reconnect" : "Login With Facebook"}
    </div>
  );

  return (
    <DestinationConfigRow
      name="Access Permission"
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={onOpenConfigModal}
    />
  );
};

const AD_ACCOUNT_ID = "AD_ACCOUNT_ID";
const OAUTH = "OAUTH";

const Rows = {
  [AD_ACCOUNT_ID]: AdAccountIDRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [AD_ACCOUNT_ID]: AdAccountIDModal,
  [OAUTH]: OAuthModal,
};

const RowOrder = [AD_ACCOUNT_ID, OAUTH];

export default {
  Rows,
  RowOrder,
  Modals,
};
